import ListOfUsers from "./shared_components/ListOfUsers"
import { Button, DialogActions, DialogContent, DialogTitle} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {useEffect} from "react"
import {
	fetchWorkspaceMembers, MANAGE_WORKSPACE_VIEW,
	//selectManageWorkspaceLoading,
	selectWorkspaceMembers, setIsInvitingAuthor, setIsLeavingWorkspace, setManageWorkspaceView
} from "../../reducers/manageWorkspaceSlice"
import PanelLoading from "../PanelLoading"
import {selectWorkspace} from "../../reducers/workspaceSlice"
import {selectUser} from "../../reducers/userSlice"
import {ManageModalContainer} from "./shared_components/ManageModalContainer"

export function ManageWorkspaceMembers() {
	const dispatch = useDispatch()
	const workspace = useSelector(selectWorkspace)
	const currentUser = useSelector(selectUser)
	const workspaceMembers = useSelector(selectWorkspaceMembers)
	const isOwnerOfWorkspace = currentUser.id === workspace.ownerUserId

	const handleInviteAuthorClick = () => {
		dispatch(setIsInvitingAuthor(true))
		dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.INVITE_AUTHOR))
	}

	useEffect(() => {
		dispatch(fetchWorkspaceMembers(selectWorkspace))
	}, [])

	return (
		<ManageModalContainer>
			<DialogTitle>Manage Workspace</DialogTitle>
			<DialogContent>
				{workspaceMembers && workspaceMembers.length > 0 ?
					<ListOfUsers members={workspaceMembers} displayingInvites={false} />
					:
					<PanelLoading />
				}
			</DialogContent>
			<DialogActions>
				{ workspace.permissions.admin &&
					<Button
						variant={"outlined"}
						onClick={() => dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.ADD_NEW_MEMBER))}
					>
						Invite Member
					</Button>
				}
				{ workspace.ownerIsSuperadmin && workspace.permissions.admin &&
					<>
						<Button
							variant={"outlined"}
							onClick={handleInviteAuthorClick}
						>
							Invite Author
						</Button>
						<Button
							variant={"outlined"}
							onClick={() => dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.MANAGE_INVITES))}
						>
							Manage Author Invites
						</Button>
					</>
				}
				<Button
					variant={"outlined"}
					onClick={() => dispatch(setIsLeavingWorkspace(true))}
					color={"error"}
					fullWidth={workspace.permissions.admin === false}
					disabled={isOwnerOfWorkspace}
				>
					Leave Workspace
				</Button>

			</DialogActions>
		</ManageModalContainer>
	)
}